import React from "react";

import {
  useMiddleware,
  EmitFunction,
} from "@piqnt/runtime-core/react/ReactMount";
import { SpaceContext } from "../space";

import { getLabel } from "@piqnt/runtime-core/common/Label";
import { getKey, type PlainJoint } from "@piqnt/runtime-space/drawing-model";

interface LiveJointComponentProps {
  emit: EmitFunction;
  joint: PlainJoint;
  selected: boolean;
  selectable?: boolean;
}

class LiveJointComponent extends React.PureComponent<LiveJointComponentProps> {
  handleClick = () => {
    const { emit, joint } = this.props;
    emit("select-joint", { joint: getKey(joint) });
  };

  render() {
    const { joint, selected, selectable } = this.props;
    if (!joint) {
      return null;
    }
    const label = getLabel(joint);
    let className = "";
    className += selected ? "selected-item " : "";
    className += selectable ? "clickable " : "";
    return (
      <span
        className={className}
        onClick={selectable ? this.handleClick : null}
      >
        {label ? "joint#" + label : (joint.type ?? "")}
      </span>
    );
  }
}

interface LiveJointProps {
  joint: PlainJoint;
  selectable?: boolean;
}

export const LiveJoint = (props: LiveJointProps) => {
  const { context, emit } = useMiddleware<SpaceContext>();
  const jointKey = getKey(props.joint);
  const selected = !!context.multiselect.value.findKey(jointKey);

  return (
    <LiveJointComponent
      joint={props.joint}
      selectable={props.selectable}
      emit={emit}
      selected={selected}
    />
  );
};
